import React, {setState, useState} from 'react';
import PropTypes from 'prop-types';
import CustomPageDetailContentHeader from './CustomPageDetailContentHeader';
import CustomPageDetailContentEcMiddleLayoutItem from './CustomPageDetailContentEcMiddleLayoutItem';
import CustomPageDetailContentEcModalItem from './CustomPageDetailContentEcModalItem';

import { useTranslation } from 'react-i18next';

const CustomPageDetailContentEcMiddleLayout = (props) => {

  let {
    pageBlockItem,
  } = props;

  let {t} = useTranslation('application');

  const [lastItemRenderedIndex, setLastItemRenderedIndex] = useState(0);

  const numberOfItemsToRenderPc = props.pageBlock.pageBlockLayoutType.pageBlockItemsPerLinePcViewCount;
  const numberOfItemsToRenderSp = props.pageBlock.pageBlockLayoutType.pageBlockItemsPerLineSpViewCount;
  const totalNumberOfItems = props.pageBlock.pageBlockItems.length;

  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     lastItemRenderedIndex: 0
  //   }

  //   this.numberOfItemsToRenderPc = props.pageBlock.pageBlockLayoutType.pageBlockItemsPerLinePcViewCount;
  //   this.totalNumberOfItems = props.pageBlock.pageBlockItems.length;
  // }

  const showMore = (e) => {
    e.preventDefault();
    setLastItemRenderedIndex(lastItemRenderedIndex + numberOfItemsToRenderPc);
    // let lastItemRenderedIndex = this.state.lastItemRenderedIndex + this.numberOfItemsToRenderPc;
    // this.setState({
    //   lastItemRenderedIndex: lastItemRenderedIndex
    // });
  }

  console.log('Rendering ec-item-middle');

  let pageBlock = props.pageBlock;
  let itemsToRenderIndex = lastItemRenderedIndex + numberOfItemsToRenderPc;

  let ecItems = pageBlock.pageBlockItems.slice(0, itemsToRenderIndex).map(function(pageBlockItem, i){
    return <CustomPageDetailContentEcMiddleLayoutItem columns={numberOfItemsToRenderPc} columnsSp={numberOfItemsToRenderSp} pageBlockItem={pageBlockItem} key={i} />;
  });

  // ====== Disable modal support for first release
  // let ecItemModals = pageBlock.pageBlockItems.slice(0, itemsToRenderIndex).map(function(pageBlockItem, i){
  //   return <CustomPageDetailContentEcModalItem pageBlockItem={pageBlockItem} key={i} />;
  // });

  return (
    <React.Fragment>
      <div className="m_bdBox" id={"page_block_" + pageBlock.pageBlockId}>
        <CustomPageDetailContentHeader pageBlock={pageBlock}/>
        <div className="">
          <ul className="product-list highlight row matchHeight">
            {ecItems}
          </ul>
        </div>
        
        {itemsToRenderIndex < totalNumberOfItems && <a href="#" className="btn btn-block btn-xxl btn-default border-0" onClick={showMore}>{t('common.seeMore')}</a>}
      </div>

      {/*{ecItemModals}*/}
    </React.Fragment>
  );
};

CustomPageDetailContentEcMiddleLayout.propTypes = {
  pageBlockItem: PropTypes.any.isRequired
};

export default CustomPageDetailContentEcMiddleLayout;